import React from 'react';

import { createServicePageLayoutClassName } from './servicePageLayoutStyles';

type Props = {
  size?: 'm' | 'l' | 'auto';
  sidebarContent: React.ReactNode;
  bodyContent: React.ReactNode;
  controls?: React.ReactNode;
};

export const ServicePageLayoutComponent = (props: Props) => {
  const { size = 'm', sidebarContent, bodyContent, controls } = props;

  const wrapperClassName = createServicePageLayoutClassName('wrapper');

  const sidebarClassName = createServicePageLayoutClassName('sidebar');

  const bodyClassName = createServicePageLayoutClassName('body');

  const bodyContentClassName = createServicePageLayoutClassName('bodyContent', {
    size,
  });

  const controlsClassName = createServicePageLayoutClassName('controls');

  return (
    <div className={wrapperClassName}>
      <div className={sidebarClassName}>{sidebarContent}</div>
      <div className={bodyClassName}>
        <div className={bodyContentClassName}>{bodyContent}</div>
      </div>
      <div className={controlsClassName}>{controls}</div>
    </div>
  );
};
